import PropTypes from 'prop-types';

export default {
  propTypes: PropTypes.shape({
    awards: PropTypes.string,
    quizResultText: PropTypes.string,
    name: PropTypes.string,
    backgroundVideo: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    }),
    firstName: PropTypes.string,
    image: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    }),
    lastName: PropTypes.string,
    link: PropTypes.string,
    middleName: PropTypes.string,
    overview: PropTypes.string,
    title: PropTypes.string
  }),

  default: {
    awards: '',
    quizResultText: '',
    name: '',
    backgroundVideo: {
      title: '',
      url: ''
    },
    firstName: '',
    image: {
      title: '',
      url: ''
    },
    lastName: '',
    link: '',
    middleName: '',
    overview: '',
    title: ''
  }
};
